export const PARTYKIT_HOST =
  import.meta.env.VITE_PARTYKIT_HOST || "http://localhost:1999";
